import UpdateActivity from './UpdateActivity'
export default UpdateActivity
